module.exports = __webpack_public_path__ + "static/media/preparation_white.e37bcdbe.svg";